<div class="container">
  <button class="toggle" [class.dark-mode]="dark" (click)="toggleTheme()">
    <div class="knob">
      <ng-container *ngIf="dark; else sunIcon">
        🌙
      </ng-container>
      <ng-template #sunIcon>
        ☀️
      </ng-template>
    </div>

  </button>
</div>